// Bootstrap
import Bootstrap from 'bootstrap/bootstrap';

Bootstrap();
